import React from 'react';
interface ButtonProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'outline';
  className?: string;
}
export function Button({
  children,
  variant = 'primary',
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 text-sm font-medium tracking-wide uppercase transition-all duration-300 ease-out rounded-sm';
  const variants = {
    primary: 'bg-teal text-cream hover:bg-teal/90 shadow-sm hover:shadow-md',
    outline: 'border border-teal text-teal hover:bg-teal hover:text-cream'
  };
  return <a className={`${baseStyles} ${variants[variant]} ${className}`} {...props} data-id="element-215">
      {children}
    </a>;
}